import { z } from 'zod';

import type { CreateCountryLangRequestViewModel } from '@/shared/api/generated';

/**
 * Schema do formulário de Idioma do país (criar/editar). Validado por Zod (React
 * Hook Form + resolver).
 *
 * NÃO derivado de `createCountryLangRequestViewModelSchema` (gerado pelo Kubb):
 * aquele schema é exportado com o cast `as unknown as ToZod<...>`, que degrada o
 * `z.infer` para `never`. Por isso é definido aqui, endurecendo `cultureInfo` e
 * `name` como obrigatórios e `active` como boolean, refletindo os campos
 * `Idioma*`/`Nome*`/`Ativo` do protótipo `design/location.pen`.
 */
export const countryLangFormSchema = z.object({
  cultureInfo: z.string().trim().min(1),
  name: z.string().trim().min(1),
  active: z.boolean(),
});

/**
 * Valores do formulário de Idioma do país (create/edit).
 *
 * O tipo intersecta com uma asserção nula (no-op) que só permanece `unknown`
 * enquanto `cultureInfo | name | active` continuarem existindo em
 * `CreateCountryLangRequestViewModel` — se um for renomeado/removido no contrato
 * gerado pelo Kubb, a asserção vira `never` e o `yarn type-check` quebra aqui.
 */
export type CountryLangFormValues = z.infer<typeof countryLangFormSchema> &
  ('cultureInfo' | 'name' | 'active' extends keyof CreateCountryLangRequestViewModel
    ? unknown
    : never);
